import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getColorAndFontManifest } from 'redux/selectors/manifest';

/**
 *
 * @param {*} props
 * @returns
 */
const TextDemiBold= (props) => {
    const { children, style = {}, className } = props;
    const { fonts = {}, colors = {} } = useSelector(getColorAndFontManifest());

    const { primary: primaryFont = {} } = fonts;
    const { component_text_color } = colors;

    return (
        <CustomText
            className={className}
            color={component_text_color}
            font={primaryFont.family}
            style={{ ...style }}
        >
            {children}
        </CustomText>
    );
};

export default TextDemiBold;

const CustomText = styled.span`
    color: ${props => props.color || '#121216'};
    font-family: ${props => props.font || 'AvenirNext-DemiBold'};
    font-weight: 600;
    font-size: 13px;
`;
